import { PromotionType } from "./promotion-type";

export class PromotionBrand {
  _id: string = "";
  name: string = "";
  logo: string = "";
  phone: string = "";
  banner: string = "";
  description: string = "";
  promotions: PromotionType[] = [];

  constructor(data?: Partial<PromotionBrand>) {
    Object.assign(this, data);
  }
}



